module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-ivoor-brillenmerk-verpakking-3.2365da58.jpg";